import { Action } from 'redux'
import { RoomModalActions } from '../../../reducers/bookingCalendar/actionNames'

const toggleCreateRoomModal = (): IToggleCreate => ({
  type: RoomModalActions.ToggleCreateRoomModal,
})

const clearRoomId = (): IToggleUpdate => ({
  type: RoomModalActions.ToggleUpdateRoomModal,
})

const toggleRoomModalIsSaving = (toggle: boolean): IToggleRoomModalSaving => ({
  toggle,
  type: RoomModalActions.ToggleSaving,
})

export { toggleCreateRoomModal, clearRoomId, toggleRoomModalIsSaving }
export type IToggleCreate = Action<RoomModalActions.ToggleCreateRoomModal>
export type IToggleUpdate = Action<RoomModalActions.ToggleUpdateRoomModal>

export interface IToggleRoomModalSaving
  extends Action<RoomModalActions.ToggleSaving> {
  toggle: boolean
}
